import styled from "styled-components";

const Container = styled.div`
  position: relative;
  width: 100%;
  margin: 0.75rem 0;
`;

export default Container;
